import React from "react";
import { successLogo } from "../../../assets/images";
import { formatAmount } from "../../../utils/formatTime";
import SurveyCard from "../../../components/survey/SurveyCard";

type NairaWithdrawSuccessProps = {
  setOpenWithdrawSuccess: (open: boolean) => void;
  setOpenWithdraw: (open: boolean) => void;
  amount: string;
};

const NairaWithdrawSuccess: React.FC<NairaWithdrawSuccessProps> = ({
  setOpenWithdrawSuccess,
  setOpenWithdraw,
  amount,
}) => {
  return (
    <div className="fixed inset-0 z-[131] flex items-start justify-start overflow-auto bg-[#E7EBEE] pb-16 pt-16 font-manrope dark:bg-primary_dark dark:bg-opacity-95 backdrop-blur-sm">
      <div className="mx-auto w-11/12 rounded-xl border bg-white p-6 dark:border-[#303030] dark:bg-[#192025] mds:w-8/12 lgss:w-2/5 xxl:w-1/3">
        <div className="flex w-full flex-col items-center justify-center gap-4 px-3 md:px-6">
          <div className="h-[116px] w-[116px]">
            <img src={successLogo} className="h-full w-full bg-cover" alt="" />
          </div>
          <h4 className="text-center font-sora text-[24px] font-bold text-gray-900 dark:text-gray-100">
            Withdrawal initiated
          </h4>
          {/* Payouts are queued on the backend, so this is "processing", not "done". */}
          <h4 className="text-center text-[15px] font-medium text-gray-500 dark:text-gray-400">
            Your withdrawal of ₦{formatAmount(Number(amount))} from your DeeX
            NGN Wallet is being processed and will arrive in your bank account
            shortly.
          </h4>
        </div>
        {/* Renders only when the admin gave the survey the TRANSACTION_SUCCESS
            placement; nothing shows otherwise. */}
        <SurveyCard placement="TRANSACTION_SUCCESS" className="mt-8" />
        <button
          type="button"
          onClick={() => {
            setOpenWithdrawSuccess(false);
            setOpenWithdraw(false);
          }}
          className="mt-32 flex h-[48px] w-full items-center justify-center rounded-xl bg-secondary_button text-[15px] font-medium text-white"
        >
          Done
        </button>
        <button
          type="button"
          onClick={() => setOpenWithdrawSuccess(false)}
          className="mt-4 flex h-[48px] w-full items-center justify-center rounded-xl border border-secondary_button text-[15px] font-medium text-secondary_button"
        >
          Make another withdrawal
        </button>
      </div>
    </div>
  );
};

export default NairaWithdrawSuccess;
